import styled from 'styled-components';
import { ContainedModal } from 'src/components/shared/ContainedModal';

export const Header = styled.div`
    padding-bottom: 1.5rem;
    margin: auto;
`;

export const DriverDetails = styled.div`
    font-size: 2rem;
    font-weight: bold;
    display: flex;
    position: relative;
`;

export const DriverDetailsLabel = styled.span`
    flex-basis: 93%;
`;

export const DriverDetailsNote = styled.div`
    font-size: 1.4rem;
    margin-top: 0.8rem;
`;

export const DriverDetailsNoteParagraph = styled.p`
    margin: 0.8rem 0 0 0;
`;

export const DriverDetailsNoteBold = styled.span`
    font-weight: bold;
`;

export const StyleContainedModal = styled(ContainedModal)`
    & > button {
        margin-top: 0.2rem;
    }
    .rc-dialog {
        width: 100% !important;
        .rc-dialog-body {
            font-size: 1.4rem;
            a {
                color: ${({ theme: { colors } }) => colors.secondaryOrange};
            }
        }
    }
`;

export const ContainedModalParagraph = styled.p`
    margin: 0.8rem 0 0 0;

    &:first-child {
        margin-top: 0;
    }
`;
